module.exports = "/packs/banner-mc-sp-f0a94a77fd491c5e11a1e3f8387b640f.png";